/**
 * Created by mykurisu on 2017/8/14.
 */
const defaults = {
    liveroom_id: null,
    liveroomSettingMainInit: false,
    liveroomInfo: null,
    liveroomManageInit: false,
    liveroomManage: null,
    liveroomBanInit: false,
    liveroomBan: null,
    liveroomBanList: null
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'LIVEROOM_ID_SAVE':
            return {...state, liveroom_id: action.payload};
        case 'LIVEROOMSETTINGINIT':
            return {...state,liveroomSettingMainInit: true, liveroomInfo: action.payload};
        case 'LIVEROOM_MANAGE_INIT':
            return {...state, liveroomManageInit: true, liveroomManage: action.payload};
        case 'LIVEROOM_BAN_INIT':
            return {...state, liveroomBanInit: true, liveroomBan: action.payload};
        case 'LIVEROOM_BAN_LIST':
            return {...state, liveroomBanList: action.payload};
        case 'LIVEROOM_BAN_CLEAR':
            return {...state, liveroomBanInit: false, liveroomBan: null, liveroomBanList: null}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/liveroomSetting.js